class MergeService {
  public static deepMerge(target, ...sources: Partial<Record<string, any>>[]) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (typeof target === 'object' && typeof source === 'object') {
      for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
            if (!target[key]) Object.assign(target, { [key]: {} });
            MergeService.deepMerge(target[key], source[key]);
          } else {
            Object.assign(target, { [key]: source[key] });
          }
        }
      }
    }

    return MergeService.deepMerge(target, ...sources);
  }

  public static deepMergeObjects<T extends Record<string, any>>(target: T, ...sources: Record<string, any>[]): T {
    const result: Record<string, any> = { ...target };

    for (const source of sources) {
      for (const key of Object.keys(source)) {
        const sourceValue = source[key];
        const targetValue = result[key];

        if (this.isObject(sourceValue) && this.isObject(targetValue)) {
          result[key] = MergeService.deepMergeObjects(targetValue, sourceValue);
        } else {
          result[key] = sourceValue;
        }
      }
    }

    return result as T;
  }

  public static deepMergeWithArrays(object1: Record<string, any>, object2: Record<string, any>) {
    const result = { ...object1 };

    for (const key in object2) {
      if (Array.isArray(object2[key]) && Array.isArray(result[key])) {
        result[key] = [...result[key], ...object2[key]];
      } else if (
        typeof object2[key] === 'object' &&
        object2[key] !== null &&
        typeof result[key] === 'object' &&
        result[key] !== null &&
        !Array.isArray(result[key])
      ) {
        result[key] = MergeService.deepMergeWithArrays(result[key], object2[key]);
      } else {
        result[key] = object2[key];
      }
    }

    return result;
  }

  private static isObject(item: unknown): item is Record<string, unknown> {
    return item !== null && typeof item === 'object' && !Array.isArray(item);
  }
}

export default MergeService;
